import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlatziComponent } from './simple-icons-platzi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlatziComponent ],
    exports:      [ SimpleIconsPlatziComponent ],
    bootstrap:    []
})
export class SimpleIconsPlatziModule {}
